import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Textarea as TaroTextarea, View, Text, } from "../_core/components";
import { useDefaultValue } from "../_util/use-default";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { noop } from "../_util/noop";
import { useConfig } from "../_util/use-config";
export var Textarea = forwardRefWithStatics(function Textarea(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var _a = useDefaultValue(props, ""), value = _a.value, onChange = _a.onChange, count = _a.count, maxlength = _a.maxlength, _b = _a.height, height = _b === void 0 ? "48px" : _b, _c = _a.onInput, onInput = _c === void 0 ? noop : _c, className = _a.className, style = _a.style, restProps = __rest(_a, ["value", "onChange", "count", "maxlength", "height", "onInput", "className", "style"]);
    return (React.createElement(View, { className: classNames(classPrefix + "-field", classPrefix + "-field__textarea", className), style: style },
        React.createElement(TaroTextarea, __assign({}, restProps, { ref: ref, holdKeyboard: true, disableDefaultPadding: true, className: classNames(classPrefix + "-field__textarea-item"), style: { height: height }, placeholderClass: classPrefix + "-field__placeholder", value: value, onInput: function (event) {
                onChange(event.detail.value, { event: event });
                return onInput(event);
            }, maxlength: maxlength })),
        count && maxlength > 0 && (React.createElement(View, { className: classPrefix + "-field__textarea-counter" },
            React.createElement(Text, { className: classPrefix + "-field__textarea-current" }, value.length),
            " ",
            "/ ",
            maxlength))));
}, {
    displayName: "Textarea",
});
//# sourceMappingURL=Textarea.js.map